// removed by extract-text-webpack-plugin
module.exports = {"slider_action":"Slider__slider_action__y_xeP","slider_amount":"Slider__slider_amount__LTDQz"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Slider/Slider.scss
// module id = 135
// module chunks = 0